import { Role } from '@caresend/types';
import { formatTimeZoneDateSimple, formatTimeZoneDate, formatCentsToDollar, getPluralCount } from '@caresend/utils';
import { defineComponent, computed } from 'vue';
import LockIcon from '../../../assets/icons/lock.svg.js';
import __vue_component__ from '../../cards/BasicCard/BasicCard.vue.js';
import { usePortalStore } from '../portal/store/portal/index.js';
import { getItineraryEndTime, getItineraryStatusDisplay, handleItineraryClick } from './controller.js';
import { getNurseViewItineraryStatus, NurseViewItineraryStatus } from './helpers.js';
import __vue_component__$1 from '../../ui/Icon.vue.js';
import '../portal/store/portal/sessionStore.js';
import 'file-saver';
import '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/encryption/model.js';
import 'js-sha256';
import { getStore } from '../../../store/helpers/initStore.js';
import 'lodash.clonedeep';
import 'lodash.isequal';
import '../portal/store/storeUtilities/dbSync/dbSyncStore.js';
import { getUserRole } from '../../../store/helpers.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../database/firebaseConfig/init.js';
import '../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'immutability-helper';
import '../../../router/routes/dev/model.js';
import '../../../router/routes/dev/routes.js';
import '../../../router/routes/dashboard/model.js';
import '../../../router/routes/pro/model.js';
import '../../../router/routes/visitsPage/model.js';
import '../../../router/routes/orderFlow/model.js';
import '../../../router/routes/orderFlow/privateHelpers.js';
import '../../../router/routes/orderFlow/routes.js';
import '../../../router/routes/schedulingFlow/model.js';
import '../../../router/routes/schedulingFlow/routes.js';
import '../../../router/routes/chartingFlow/model.js';
import '../../../router/routes/chartingFlow/routes.js';
import '../../../router/routes/portal/portalRoutes.js';
import '../../../router/routes/portal/model.js';
import '../../../router/routes/visitsPage/routes.js';
import '../dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../store/modules/app/model.js';
import '../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../store/modules/chartingFlow/model.js';
import '../../../store/modules/office/index.js';
import '../VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../store/modules/office/model.js';
import '../../../store/modules/orderFlow/index.js';
import '../../../store/modules/procedures/model.js';
import '../../../store/modules/schedulingFlow/index.js';
import '../../../store/modules/schedulingFlow/model.js';

var script = defineComponent({
    name: 'ShiftItineraryCard',
    components: {
        BasicCard: __vue_component__,
        Icon: __vue_component__$1,
        LockIcon,
    },
    props: {
        shift: {
            type: Object,
            required: true,
        },
        itinerary: {
            type: Object,
            required: true,
        },
        clickable: Boolean,
        displayPayout: Boolean,
        displayPlaceGroupNames: Boolean,
        displayStatus: Boolean,
        displayLockIcon: Boolean,
        to: {
            type: [String, Object],
            default: null,
        },
    },
    setup(props) {
        const store = getStore();
        const portalStore = usePortalStore();
        const shiftStartTime = computed(() => { var _a, _b; return (_b = (_a = props.shift.startTime) === null || _a === void 0 ? void 0 : _a.timestamp) !== null && _b !== void 0 ? _b : Infinity; });
        const shiftStatus = computed(() => props.shift.status);
        const endTime = computed(() => getItineraryEndTime(props.itinerary));
        const startTimeFormatted = computed(() => formatTimeZoneDateSimple(props.itinerary.startTime, 'h:mm a'));
        const endTimeFormatted = computed(() => formatTimeZoneDate(endTime.value, 'h:mm a z'));
        const title = computed(() => `${startTimeFormatted.value} to ${endTimeFormatted.value}`);
        const itineraryEarnings = computed(() => formatCentsToDollar(props.itinerary.baseNurseEarnings));
        const numberOfWaypoints = computed(() => { var _a, _b; return (_b = (_a = props.itinerary.waypoints) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0; });
        const numberOfPatients = computed(() => portalStore.itinerary.getters.numberOfPatients(props.itinerary.id));
        const subtitle = computed(() => {
            const stops = getPluralCount(numberOfWaypoints.value, 'stop');
            const patients = getPluralCount(numberOfPatients.value, 'patient');
            return `${stops} - ${patients}`;
        });
        const isNurse = computed(() => getUserRole() === Role.NURSE);
        const nurseCheckInThreshold = computed(() => isNurse.value ? store.getters['variables/getShiftCheckInThreshold'] : undefined);
        /** The status of the itinerary for nurses only */
        const nurseViewItineraryStatus = computed(() => isNurse.value
            ? getNurseViewItineraryStatus(shiftStatus.value, shiftStartTime.value)
            : undefined);
        const isNurseEarlyForCheckIn = computed(() => isNurse.value
            && nurseViewItineraryStatus.value === NurseViewItineraryStatus.CHECK_IN_INELIGIBLE);
        const isItineraryViewable = computed(() => props.clickable && !isNurseEarlyForCheckIn.value);
        const itineraryStatusDisplay = computed(() => getItineraryStatusDisplay(props.itinerary.status, nurseViewItineraryStatus.value));
        return {
            endTimeFormatted,
            handleItineraryClick,
            isNurse,
            isNurseEarlyForCheckIn,
            isItineraryViewable,
            itineraryEarnings,
            itineraryStatusDisplay,
            numberOfWaypoints,
            nurseCheckInThreshold,
            startTimeFormatted,
            subtitle,
            title,
        };
    },
});

export { script as default };
